module.exports = __webpack_public_path__ + "img/zhinengzhizao_zhonghuan_suoluetu.b9e893d9.png";